import { Link, useParams } from "react-router-dom";
import { Printer, ArrowLeft } from "@phosphor-icons/react";
import { useFetch } from "@/lib/useFetch";
import { fmtDate } from "@/lib/api";
import { Loader } from "@/components/Blocks";

const Row = ({ label, sub, count, tid }) => (
  <tr className="border-b"><td className="py-2 pr-4">{label}{sub && <div className="text-xs text-[#475569]">{sub}</div>}</td><td className="py-2 text-right font-mono-num text-lg font-semibold" data-testid={tid}>{count}</td></tr>
);

const DayBlock = ({ day, d, i }) => (
  <div className="break-inside-avoid rounded-md border p-4" data-testid={`sheet-day-${i}`}>
    <div className="eyebrow">Day {i + 1} · {fmtDate(day.start_at, d.event.timezone)}</div>
    <div className="font-semibold">{day.title}</div>
    <table className="mt-2 w-full text-sm"><tbody>
      <Row label={d.breaks[0].label} sub={d.breaks[0].menu} count={d.breaks[0].count} tid={`sheet-am-break-${i}`} />
      <Row label="Lunch: Meat (chicken)" count={d.meals["Meat (chicken)"]} tid={`sheet-chicken-${i}`} />
      <Row label="Lunch: Vegan" count={d.meals.Vegan} tid={`sheet-vegan-${i}`} />
      {d.meals["Not chosen yet"] > 0 && <Row label="Lunch: meal not chosen yet" count={d.meals["Not chosen yet"]} tid={`sheet-unchosen-${i}`} />}
      <Row label={d.breaks[1].label} sub={d.breaks[1].menu} count={d.breaks[1].count} tid={`sheet-pm-break-${i}`} />
    </tbody></table>
  </div>
);

export default function LunchSheet() {
  const { eventId } = useParams();
  const { data: d, loading, error } = useFetch(`/admin/events/${eventId}/catering`);
  if (loading) return <Loader />;
  if (error) return <p className="text-sm text-[#C8382E]">{error}</p>;
  return (
    <div className="print-area mx-auto max-w-3xl bg-white p-6 sm:p-10" data-testid="lunch-sheet">
      <div className="no-print mb-6 flex justify-between gap-2">
        <Link to="/superadmin/registrations" className="btn-outline" data-testid="lunch-sheet-back"><ArrowLeft /> Back</Link>
        <button className="btn-navy" onClick={() => window.print()} data-testid="lunch-sheet-print-btn"><Printer /> Print</button>
      </div>
      <div className="eyebrow">Catering order</div>
      <h1 className="mt-1 font-display text-4xl font-black uppercase leading-none text-[#0B1B33]">{d.event.title}</h1>
      <p className="mt-2 text-sm text-[#475569]" data-testid="lunch-sheet-venue">{d.event.venue} · {d.event.address} · {d.event.city}</p>
      <p className="text-sm"><span className="font-semibold">Total attendees:</span> <span className="font-mono-num" data-testid="lunch-sheet-total">{d.lunch_count}</span> per day · <span data-testid="lunch-sheet-confirmed">{d.confirmed_yes} confirmed coming</span>{d.released > 0 && <span> · {d.released} released (not counted)</span>}</p>
      <div className="mt-6 grid gap-4 sm:grid-cols-2">{d.days.map((day, i) => <DayBlock key={i} day={day} d={d} i={i} />)}</div>
      <h2 className="mt-8 font-display text-2xl font-bold uppercase">Allergies and dietary notes</h2>
      {d.allergies.length === 0 ? <p className="mt-2 text-sm" data-testid="lunch-sheet-no-allergies">No allergies reported.</p> : (
        <table className="mt-2 w-full text-sm" data-testid="lunch-sheet-allergies"><thead className="text-left text-xs uppercase tracking-wider text-[#475569]"><tr><th className="py-1">Name</th><th className="py-1">Meal</th><th className="py-1">Allergies</th></tr></thead>
          <tbody>{d.allergies.map((a, i) => <tr key={i} className="border-t"><td className="py-1.5 font-semibold">{a.name}</td><td className="py-1.5">{a.meal}</td><td className="py-1.5 font-semibold text-[#C8382E]">{a.allergies}</td></tr>)}</tbody></table>
      )}
      {d.not_chosen.length > 0 && <p className="mt-4 text-xs text-[#475569]" data-testid="lunch-sheet-unchosen-names">Meal not chosen yet: {d.not_chosen.join(", ")}</p>}
      <p className="mt-8 text-xs text-[#475569]">Counts exclude cancelled and refunded tickets. Printed {fmtDate(new Date().toISOString())}.</p>
    </div>
  );
}
